import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import { RenderingRegistry } from 'common/lib/registries';
import useShowItemNotPublished from 'modules/productsModule/hooks/useShowItemNotPublished';
import { ProductsComponentProps, ProductComponentMapType } from '../../../../common/types';
import { usePersistedCountryDetails } from '../../../../common/hooks';
import FoodProducts from './components/FoodProducts';
import FashionProducts from './components/FashionProducts';
import GroceryProducts from './components/GroceryProducts/index';
import { LAYOUT_ONE, LAYOUT_THREE, LAYOUT_TWO } from '../../../../common/constants';

const productComponentMap: ProductComponentMapType = {
  [LAYOUT_ONE]: FoodProducts,
  [LAYOUT_TWO]: FashionProducts,
  [LAYOUT_THREE]: GroceryProducts,
};

const Products: React.FC<ProductsComponentProps> = props => {
  const [persistedCountryDetails] = usePersistedCountryDetails();
  const layout = RenderingRegistry.getShowLayout();
  const { products } = props || {};

  const { lang, t } = useTranslation('product');
  const currency = persistedCountryDetails?.currency?.[`title_${lang}`];
  useShowItemNotPublished({ t, products });

  const Comp = productComponentMap[layout.productLayout];
  return <Comp currency={currency} {...props} />;
};
export default Products;
